// App
import React from 'react';

// Misc / utils
import { Dialog as StyledDialog } from './styles';
import Dialog from 'app/shared/modules/Dialog';

interface FilterButtonDropdownProps {
  ariaLabel: string;
  dropdownId: string;
  onClose: () => void;
  children: React.ReactNode;
}

const FilterButtonDropdown = (props: FilterButtonDropdownProps) => {
  return (
    <Dialog DialogComponent={StyledDialog} {...(props as any)}>
      {props.children}
    </Dialog>
  );
};

export default FilterButtonDropdown;
